/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Erika boira, durant deux jours, le lait de sa mère, dit colostrum, lequel renforce le système immunitaire du jeune animal.
Il boit ensuite jusqu’à la cinquième semaine 5 à 6 litres de lait produit par d’autres vaches de l’étable.
Mais de plus en plus d’exploitations fonctionnent en stabulation libre. Au cours des quatre premiers mois, le paysan n’a pas le droit d’attacher Erika.`}</p>
    <p>{`Erika est une vache laitière. Elle a ainsi eu de la chance, elle aurait pu n’être qu’un veau d'engraissement. Ces veaux quittent l’étable où ils sont
nés deux semaines à peine après le vêlage. Ils sont placés dans des halles d’engraissement avec des veaux du même âge, puis tués après sept mois au maximum.
En 2018, 217'088 veaux ont été bouchoyés - un toutes les 2,4 minutes. La viande de veau représente 6% de la consommation de viande des Suisses. La plupart des
veaux mâles sont destinés à l’engraissement. Une toute petite minorité est élevé pour la reproduction (taureau).`}</p>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  